import customFetch from '../utils/fetch';
import { API_ENDPOINTS } from '../constants/api-endpoint';

const getRegistration = async (bodyData) => {
  try {
    return await customFetch(API_ENDPOINTS.MEMBER_REGISTRATION_GET, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(bodyData),
    });
  } catch (error) {
    console.error('登録情報送信エラー:', error);
    throw error;
  }
};

const save = async (data) => {
  try {
    return await customFetch(API_ENDPOINTS.MEMBER_REGISTRATION_SAVE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  } catch (error) {
    console.error('メンバー情報の保存エラー:', error);
    throw error;
  }
};

const update = async (data) => {
  try {
    return await customFetch(API_ENDPOINTS.MEMBER_REGISTRATION_UPDATE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  } catch (error) {
    console.error('メンバー情報の更新エラー:', error);
    throw error;
  }
};

export const memberService = {
  getRegistration,
  save,
  update
};
